/**
 * Navigation constants for homepage sidebar
 */

export const NAV_ITEMS = {
  HOME: {
    label: "Home",
    path: "/",
    icon: "Home",
  },
  MY_LIBRARY: {
    label: "My Library",
    path: "/my-library/",
    icon: "Library",
  },
  LEARNING_CENTER: {
    label: "Learning Center",
    path: "https://www.youtube.com/playlist?list=PLCmEY2bUooBzva-gvuh3TpOpWoHjuRMqm",
    icon: "LearningCenter",
    external: true,
  },
  PRICING: {
    label: "Pricing",
    path: "/subscription/",
    icon: "Pricing",
  },
} as const;

export type NavItemKey = keyof typeof NAV_ITEMS;
